import { render, staticRenderFns } from "./setingPerson.vue?vue&type=template&id=d606158c&scoped=true"
import script from "./setingPerson.vue?vue&type=script&lang=js"
export * from "./setingPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d606158c",
  null
  
)

export default component.exports